import { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@sib/ui';

export interface TagProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  icon?: ReactNode;
  LabelProps?: HTMLAttributes<HTMLSpanElement> & { text?: string };
}

export const Tag = ({ className, icon, LabelProps, ...props }: TagProps) => {
  return (
    <div
      {...props}
      className={cn(
        'flex flex-row items-center justify-between gap-1 rounded-sm border px-1 text-xs leading-6 font-normal text-nowrap',
        className
      )}
    >
      {icon}
      <span className={cn('text-[10px] capitalize', LabelProps?.className)}>
        {LabelProps?.text}
      </span>
    </div>
  );
};
